import axios from 'axios'
import { computed, ref, unref } from 'vue'

const config = ref(undefined)
const isLoading = ref(false)
const hasConfig = computed(() => {
  return config.value !== undefined
})

export function useRuntimeEnv() {
  async function load() {
    if (unref(hasConfig) || unref(isLoading)) {
      // Config already loaded
      return
    }

    isLoading.value = true

    try {
      const { data } = await axios.get('/runtime.env.json')

      config.value = data
    } finally {
      isLoading.value = false
    }
  }

  return {
    config,
    load,
    hasConfig
  }
}
